<template>
    <Modal :id="'catalog-plugins-check_label'" @cancelled="onCancel">
        <template v-if="showConfirm" slot="header">{{$t('info')}}</template>
        <template v-if="showLabel" slot="header">{{$t('labels')}}</template>
        <template v-if="showFormats" slot="header">{{$t('formats')}}</template>
        <template slot="body">
            <div class="body-container">
                <ng-container v-if="showMetaDataUpload">
                    <div style="margin-bottom: 8px">
                        <button style="margin:20px 0px" class="dt-button v5 s8" @click="onChooseFileClick">
                            {{ file ? file.name : $t("Choose File") }}
                        </button>
                        <input type="file" name="cost_file" id="cost_file" style="visibility: hidden; display: none"
                            @change="onFilePickerChange" />
                    </div>
                    <div class="ut-flex">

                        <button :disabled="!file" :class="{ disabled: !file }" @click="onOkClick" class="dt-button v1 s6">

                            <template v-if="loadingFlag">
                                <img src="static/icons/loading.gif" />
                            </template>
                            <template v-else> {{ $t("Upload Meta") }}
                            </template>
                        </button>

                    </div>
                </ng-container>
                <ng-container v-if="showLabel">
                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="new_labels" :config="tableConfig"
                        :headers="headerLabels" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>
                                <td :title="item.label_name" v-bind="tdcon('labels')">
                                    <div>
                                        <span class="txtov"> {{ item.label_name }}</span>

                                    </div>
                                </td>
                                <td v-bind="tdcon('label')">
                                    <Dropdown2 :bb="'0px'" class="dbox1" :showLabel="false" :placeholder="'label'"
                                        :disabled="false" v-on:selectedChange="(e) => onLabelChange('label_id', e, item)
                                            " :options="labelsTV || []" :selected="labelsTV.find((e) => e.value == item.label_id
    )" />
                                </td>



                            </tr>
                        </template>
                    </NTable>

                </ng-container>
                <ng-container v-if="showFormats">

                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="new_formats" :config="tableConfig"
                        :headers="headerFormats" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>
                                <td :title="item.format_name" v-bind="tdcon('formats')">
                                    <div>
                                        <span class="txtov"> {{ item.format_name }}</span>

                                    </div>
                                </td>
                                <td v-bind="tdcon('format')">
                                    <Dropdown2 :bb="'0px'" class="dbox1" :showLabel="false" :placeholder="'format'"
                                        :disabled="false" v-on:selectedChange="(e) => onFormatChange('format_id', e, item)
                                            " :options="formats || []" :selected="formats.find((e) => e.value == item.format_id
    )" />
                                </td>



                            </tr>
                        </template>
                    </NTable>

                </ng-container>
                <ng-container v-if="showProducts">

                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="products" :config="tableConfig"
                        :headers="headers" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>
                                <td :title="item.product.alt_artist" v-bind="tdcon('products')">
                                    <span :style="{
                                        'color': item.product.product_id > 0 && item.product.track_count == 0 ? 'red' : '',
                                    }" class="txtov"> {{ item.product.alt_artist }}</span>
                                </td>
                                <td :title="item.product.alt_title" v-bind="tdcon('alt_title')">
                                    <span :style="{
                                        'color': item.product.product_id > 0 && item.product.track_count == 0 ? 'red' : '',
                                    }" class="txtov"> {{ item.product.alt_title }}</span>
                                </td>
                                <td :title="item.product.version" v-bind="tdcon('version')">
                                    <span :style="{
                                        'color': item.product.product_id > 0 && item.product.track_count == 0 ? 'red' : '',
                                    }" class="txtov"> {{ item.product.version }}</span>

                                </td>
                                <td :title="item.product.catalog_no" v-bind="tdcon('catalog_no')">
                                    <span :style="{
                                        'color': item.product.product_id > 0 && item.product.track_count == 0 ? 'red' : '',
                                    }" class="txtov"> {{ item.product.catalog_no }}</span>

                                </td>
                                <td :title="item.product.barcode" v-bind="tdcon('barcode')">
                                    <span :style="{
                                        'color': item.product.product_id > 0 && item.product.track_count == 0 ? 'red' : '',
                                    }" class="txtov"> {{ item.product.barcode }}</span>

                                </td>
                                <td :title="item.product.format_name" v-bind="tdcon('format_name')">
                                    <span :style="{
                                        'color': item.product.product_id > 0 && item.product.track_count == 0 ? 'red' : '',
                                    }" class="txtov"> {{ item.product.format_name }}</span>

                                </td>
                                <td v-bind="tdcon('New')">
                                    <div class="checkbox-container">
                                        <div style="margin-left:0" class="dt-checkbox v2 s1">
                                            <input type="checkbox" :name="item.ri_id" :id="item.ri_id"
                                                :checked="select_products.has(item.ri_id)" @click="(e) => onCheckboxChange(e, 'ri_id', item)
                                                    " />
                                            <div class="checkmark"></div>
                                        </div>
                                    </div>
                                </td>
                                <td v-bind="tdcon('Tracks')">
                                    <div v-if="item.product.product_id > 0 && item.product.track_count == 0"
                                        class="checkbox-container">
                                        <div style="margin-left:0" class="dt-checkbox v2 s1">
                                            <input type="checkbox" :name="item.product.product_id"
                                                :id="item.product.product_id"
                                                :checked="select_product_tracks.has(item.ri_id)" @click="(e) => onProductTrackCheckboxChange(e, 'product_id', item)
                                                    " />
                                            <div class="checkmark"></div>
                                        </div>
                                    </div>
                                </td>


                            </tr>
                        </template>
                    </NTable>

                </ng-container>
                <ng-container v-if="showTracks">
                    <NTable style="--ntable-height:300px;border:1px solid rgba(128, 128, 128, 0.158);background:#f8f8f8;"
                        class="distribution-order-check_barcode_modal" :items="tracks" :config="tableConfig"
                        :headers="headerTracks" :id="'distribution-order-check_barcode_modal'">

                        <template v-slot:item="{ item, tdcon }">
                            <tr>

                                <td  :title="item.artist" v-bind="tdcon('tracks')">
                                    <span class="txtov"> {{ item.artist }}</span>
                                </td>
                                <td :title="item.title" v-bind="tdcon('m_title')">
                                    <span class="txtov"> {{ item.title }}</span>
                                </td>
                                <td :title="item.version" v-bind="tdcon('version')">
                                    <span class="txtov"> {{ item.version }}</span>

                                </td>
                                <td :title="item.playtime" v-bind="tdcon('playtime')">
                                    <span class="txtov"> {{ item.playtime }}</span>

                                </td>
                                <td :title="item.isrc" v-bind="tdcon('isrc')">
                                    <span class="txtov"> {{ item.isrc }}</span>

                                </td>
                                <td v-bind="tdcon('CreateNew')">
                                    <div class="checkbox-container">
                                        <div style="margin-left:0" class="dt-checkbox v2 s1">
                                            <input type="checkbox" :name="item.track_id" :id="item.track_id"
                                                :checked="select_tracks.has(item.ri_id)" @click="(e) => onTrackCheckboxChange(e, 'ri_id', item)
                                                    " />
                                            <div class="checkmark"></div>
                                        </div>
                                    </div>
                                </td>





                            </tr>
                        </template>
                    </NTable>
                    <div style="margin:5px;">
                        If you want to add existing track to products, please do not un-check red lines.
                        <br />
                        Scroll down to bottom to enable PROCESS Button.
                    </div>
                </ng-container>
                <ng-container v-if="showConfirm">
                    <span>
                        You will be notified at {{ email }}, when the process is complete.
                    </span>
                </ng-container>
            </div>
        </template>

        <template slot="options">
            <button class="dt-button  s6" @click.stop="onCancel">
                {{ $t("cancel") }}
            </button>
            <button :disabled="!isValid" :class="{ disabled: !isValid }" v-if="showFormats" @click="selectedFormats"
                class="dt-button v1 s6">
                <template v-if="loadingFormatGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>
            <button v-if="showProducts" @click="selectedProducts" class="dt-button v1 s6">
                <template v-if="loadingProductGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>
            <button v-if="showTracks" @click="sendTrackData" class="dt-button v1 s6">
                <template v-if="loadingTrackGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>
            <button v-if="showLabel" @click="sendLabel" class="dt-button v1 s6">
                <template v-if="loadingLabelGif">
                    <img src="static/icons/loading.gif" />
                </template>
                <template v-else> {{ $t("Process") }}
                </template>
            </button>

        </template>
    </Modal>
</template>
  
<script>



export default {
    async mounted() {
        const resData = await window.HttpClient.get(this.URL, {
            action: "get_label_page",
            page: 1,
            rows: 10000,
        });
        this.labelsTV = resData.data.labels.map(p => {
            return {
                text: p.label_name,
                value: p.label_id,
            }
        });
    },
    data() {
        return {
            URL: '/jsonapi.pl',
            file: null,
            label_id: 0,
            labelsTV: [],
            loadingFlag: false,
            global_source_id: 0,
            loadingProductGif: false,
            loadingFormatGif: false,
            loadingTrackGif: false,
            new_formats: [],
            new_labels: [],
            formats: [],
            select_formats: [],
            select_products: new Set(),
            select_product_tracks: new Set(),
            select_tracks: new Set(),
            showProducts: false,
            showFormats: false,
            showMetaDataUpload: true,
            loadingLabelGif: false,
            showTracks: false,
            showConfirm: false,
            showLabel: false,
            tracks: [],
            pluginFlag: true,
            tableConfig: window.createNTableConfig({
                headerStyle: 3,
            }),
            email: ""
        };
    },
    computed: {
        isValid: function () {
            return this.new_formats.length === this.new_formats.filter(f => f.format_id > 0).length ? true : false;
        },
        headers: function () {
            return [
                window.createTableHeader("products", { f: 1.1 }),
                window.createTableHeader("alt_title", { text: false }),
                window.createTableHeader("version", { text: false }),
                window.createTableHeader("catalog_no", { text: false }),
                window.createTableHeader("barcode", { text: false }),
                window.createTableHeader("format_name", { text: false }),
                window.createTableHeader("New", { mw: 100 }),
                window.createTableHeader("Tracks", { mw: 100 }),

            ];

        },
        headerTracks: function () {
            return [
                window.createTableHeader("tracks", { f: 1.1 }),
                window.createTableHeader("m_title", { text: false }),
                window.createTableHeader("version", { text: false }),
                window.createTableHeader("playtime", { text: false }),
                window.createTableHeader("isrc", { text: false }),
                window.createTableHeader("CreateNew", { mw: 150, text: 'Create New/Add' }),
            ];

        },
        headerLabels: function () {
            return [
                window.createTableHeader("labels",),
                window.createTableHeader("label", { mw: 250, text: false }),
            ];

        },
        headerFormats: function () {
            return [
                window.createTableHeader("formats",),
                window.createTableHeader("format", { mw: 250, text: false }),
            ];

        },
    },
    methods: {
        onFormatChange: function (name, value, item) {
            item[name] = value.value
        },
        onLabelChange: function (name, value, item) {
            item[name] = value.value
        },
        onCheckboxChange: function (event, name, item) {
            const value = event.target.checked;
            this.select_products = window.addRemoveSet(
                event.target.checked,
                this.select_products,
                item.ri_id
            );

            console.log('this.select_products', this.select_products)
            console.log('this.item', item)
        },
        onProductTrackCheckboxChange: function (event, name, item) {
            const value = event.target.checked;
            this.select_product_tracks = window.addRemoveSet(
                event.target.checked,
                this.select_product_tracks,
                item.ri_id
            );
        },
        onTrackCheckboxChange: function (event, name, item) {
            const value = event.target.checked;
            this.select_tracks = window.addRemoveSet(
                event.target.checked,
                this.select_tracks,
                item.ri_id
            );

            console.log("WWWW", item.ri_id, value);
        },
        onOkClick: async function () {
            if (this.file) {
                this.loadingFlag = true;
                let fd = new FormData();
                fd.append("file", this.file);
                fd.append("plugin_name", "multilabel-import");
                fd.append("action", "label_import_file");
                this.loadingFlag = true;
                window.HttpClient.postFormData(this.URL, fd)
                    .then((res) => {
                        this.loadingFlag = false;
                        console.log('daaa', res.data);
                        let { source_id, email } = res.data;
                        this.global_source_id = source_id;
                        this.processLabel();
                    })
                    .catch((e) => {
                        this.$emit("cancelled", true);
                    });
            } else {
                this.$emit("cancelled", true);
            }
        },
        async processLabel() {

            let res = await window.HttpClient.post(this.URL, {
                action: "ri_process_label",
                source_id: this.global_source_id,
            });
            let { new_labels=[], labels=[] } = res.data;
            this.labelsTV = labels.map(p => {
                return {
                    text: p.label_name,
                    value: p.label_id,
                }
            });
            this.new_labels = new_labels.map(f => {
                return {
                    label_name: f,
                    label_id: 0,
                }
            });

            if (this.new_labels.length === 0) {
                this.loadingFlag = false
                this.processFormat();
            }
            else {
                this.showLabel = true;
                this.showMetaDataUpload = false;
            }
        },
        async sendLabel() {
            this.loadingLabelGif = true;
            let res = await window.HttpClient.post(this.URL, {
                action: "ri_select_labels",
                source_id: this.global_source_id,
                labels: JSON.stringify(this.new_labels),
            });
            this.loadingLabelGif = false;
            this.processFormat();
        },
        async processFormat() {
            let res = await window.HttpClient.post(this.URL, {
                action: "ri_process_format",
                source_id: this.global_source_id,
            });
            let { new_formats, formats=[] } = res.data;
            this.new_formats = [...new_formats];
            this.formats = [...formats];
            if (this.new_formats.length === 0) {
                this.loadingFlag = false
                this.processProduct();
            }
            else {
                this.showMetaDataUpload = false;
                this.showFormats = true;
                this.loadingFlag = false;
                this.showLabel = false;
                this.formats = this.formats.map(f => {
                    return {
                        text: f.format_name,
                        value: f.format_id,
                    }
                })
                this.new_formats = this.new_formats.map(f => {
                    return {
                        format_name: f,
                        format_id: 0,
                    }
                })
            }
        },
        async selectedFormats() {
            this.loadingFormatGif = true;
            const select_formats = this.new_formats.filter(f => f.format_id > 0)
            let res = await window.HttpClient.post(this.URL, {
                action: "ri_select_formats",
                source_id: this.global_source_id,
                formats: JSON.stringify(select_formats),
            });
            this.loadingFormatGif = false;
            this.processProduct();
        },
        async processProduct() {
            let res = await window.HttpClient.post(this.URL, {
                action: "ri_process_product",
                source_id: this.global_source_id,
            });
            let { products } = res.data;
            this.products = [...products]
            this.showMetaDataUpload = false;
            this.showFormats = false;
            this.showLabel = false;
            this.showProducts = true;
            const select_products = this.products.filter(p => !p.product.product_id || p.product.track_count > 0).map(p => p.ri_id);
            select_products.forEach(item => {
                this.select_products.add(item);
            });
        },
        async selectedProducts() {
            this.loadingProductGif = true;
            const selectedProducts = [];
            this.products.forEach(p => {
                const checkedNP = this.select_products.has(p.ri_id) ? 1 : 0;
                const checkedNPT = this.select_product_tracks.has(p.ri_id) ? 1 : 0;
                selectedProducts.push({
                    ri_id: p.ri_id,
                    np: checkedNP,
                    npt: checkedNPT
                });
            });
            let res = await window.HttpClient.post(this.URL, {
                action: "ri_select_products",
                source_id: this.global_source_id,
                products: JSON.stringify(selectedProducts),
            });

            this.processTrack();
        },

        async processTrack() {
            let res = await window.HttpClient.post(this.URL, {
                action: "ri_process_tracks",
                source_id: this.global_source_id,
            });
            let { products } = res.data;
            this.showTracks = true;
            this.showProducts = false;
            let tracks = [...products];

            tracks.forEach(t => {
                t.tracks = t.tracks.map((s, index) => {
                    if (index === 0) {
                        s.group_title = t.product.catalog_no + ' | ' + t.product.alt_artist + ' | ' +
                            t.product.alt_title + ' | ' + t.format.format_name
                        s.new_group_title = 1
                    }

                    s.period = t.product.catalog_no + ' | ' + t.product.alt_artist + ' | ' +
                        t.product.alt_title + ' | ' + t.format.format_name
                    s = {
                        ...s,
                        ...s.track
                    }
                    return s;
                });

                this.tracks.push(...t.tracks);
                this.tracks.forEach(item => {
                    this.select_tracks.add(item.ri_id);
                })
            });

            console.log(' this.tracks', this.tracks);
            this.loadingProductGif = false;
        },
        sendTrackData() {
            this.loadingTrackGif = true;
            let last_req = 0;
            let track_chunk = [];
            const selectedTracks = [];
            this.tracks.forEach(p => {
                const checkedNT = this.select_tracks.has(p.ri_id) ? 1 : 0;
                selectedTracks.push({
                    ri_id: p.ri_id,
                    nt: checkedNT,

                });
            });
            if (selectedTracks.length > 1000) {
                track_chunk = selectedTracks.splice(0, 1000);
            } else {
                last_req = 1;
                track_chunk = selectedTracks.splice(0);
            }

            window.HttpClient.post(this.URL, {
                action: "ri_select_tracks",
                source_id: this.global_source_id,
                total_track: track_chunk.length,
                tracks: JSON.stringify(track_chunk),
            }).then((res) => {
                this.loadingTrackGif = false;
                if (last_req) {
                    this.confirmImport(res.data);
                } else {
                    this.send_track_data();
                }
            });

        },
        confirmImport(data) {
            let { email } = data;
            window.HttpClient.post(this.URL, {
                action: "process_multilabel_import",
                source_id: this.global_source_id,

            }, {
                crossDomain: true,
                xhrFields: {
                    withCredentials: true,
                },
            }).then((data) => {
                this.showConfirm = true;
                this.showTracks = false;
                this.email = email;
            });

        },
        onCancel: async function () {
            this.pluginFlag = false;
            if (this.global_source_id && !this.showConfirm) {
                let res = await window.HttpClient.post(this.URL, {
                    action: "cancel_label_import",
                    source_id: this.global_source_id,
                });
            }
        },
        onFilePickerChange: function (event) {
            const files = event.target.files;
            if (files.length > 0) {
                this.file = files[0];
                console.log({ "this.file": this.file });
            }
        },
        onChooseFileClick() {
            document.querySelector("#cost_file").click();
        },
        onDropdownChange(name, value) {
            this.label_id = value.value
        }
        //MARK: Methods
    },
};
</script>